<template>
  <!--
      作者 gmshop
      时间：2012-12-5
      描述：设置-设置
  -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">排队奖励设置</div>
      <el-form-item label="是否开启排队奖励：">
        <el-radio-group v-model="form.is_open" :rules="[{required: true,message: ' '}]">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="奖励层数：" prop="award_num" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.award_num" type="number" :min="1" :max="10" :step="1" placeholder="请输入层数" class="max-w460"><template slot="append">层</template></el-input>
      </el-form-item>

      <el-form-item label="每层奖励：" prop="award" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.award" type="number" :min="0" :max="100" placeholder="请输入奖励" class="max-w460"><template slot="append">%</template></el-input>
      </el-form-item>

      <el-form-item label="队列金额设置：" prop="product_price" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.product_price" type="number" :min="0" placeholder="请输入队列金额" class="max-w460"><template slot="append">元</template></el-input>
        <div class="lh18 mt10 red">
          <p>例如：队列金额为299，金额小于或等于299元的订单归属队列1，金额大于299的订单归属队列2</p>
        </div>
      </el-form-item>

      <el-form-item label="是否开启自购额外奖励：">
        <el-radio-group v-model="form.is_open_oneself">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="额外奖励设置：" v-if="form.is_open_oneself==1">
        <div  class="max-w460">
          <el-table
            :data="grade_list"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="会员等级">
            </el-table-column>
            <el-table-column
              prop="name"
              label="额外奖励">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.award" type="number" :min="0" :max="100" placeholder="请输入奖励"></el-input>
                  <span class="ml10">%</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

    <div style="clear: both; height: 100px;width: 100rpx;"></div>


      <!-- region_agent -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import QueuerebateApi from '@/api/queuerebate.js';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{},
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,
          award_num: '',
          award: '',
          product_price: '',
          is_open_oneself: 0,
        },
        grade_list: [],
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        QueuerebateApi.getSetting({}, true)
          .then(res => {
            let vars = res.data.setting;
            self.form = formatModel(self.form, vars);
            self.form.is_open = vars.is_open || self.form.is_open;
            self.form.award_num = vars.award_num || self.form.award_num;
            self.form.award = vars.award || self.form.award;
            self.form.product_price = vars.product_price || self.form.product_price;
            self.form.is_open_oneself = vars.is_open_oneself || self.form.is_open_oneself;

            self.grade_list = res.data.grade_list;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },

      /*转JSON字符串*/
      convertJson(list) {
        let obj = {};

        list.forEach(item => {
          obj[item.grade_id] = item.award;
        });

        return JSON.stringify(obj);
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        params.award_detail = self.convertJson(self.grade_list);
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            QueuerebateApi.saveSetting(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/queuerebate/setting/index.vue